export function getCurrentUrl(pathname: any) {
  // return pathname.split(/[?#]/)[0]
  return pathname
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)

  if (!current.pathname || !url) {
    return false
  }

  if (current.pathname === url) {
    return true
  }

  if (current.search === '?type=Assigned' && url.includes('?type=Assigned')) {
    return true
  }

  if (current.search === '?type=Resolved' && url.includes('?type=Resolved')) {
    return true
  }

  if (current.pathname.indexOf(url) > -1) {
    return true
  }

  return false
}
